module.exports = __webpack_public_path__ + "img/icon-bar.5f7b421b.png";